import { useInfiniteQuery } from '@tanstack/react-query'
import { VirtualCardAPI } from '@apis'

type StatusParam = typeof VirtualCardAPI.GetUserGroupsRequest.statuses[number]

export function useUserGroups(userId: string | undefined | null, status: StatusParam = 'active', pageSize: number = 10) {
    return useInfiniteQuery({
        queryKey: ['user-groups', userId, status],
        queryFn: ({ pageParam = 1 }) => VirtualCardAPI.GetUserGroupsRequest.fetch(userId!, { page: pageParam, size: pageSize, status }),
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.length < pageSize ? undefined : allPages.length + 1
        },
        initialPageParam: 1,
        enabled: !!userId,
        staleTime: 600000 // 10 minutes
    })
}
